import { css } from "@emotion/react"

export const container = css`
	border: 1px solid #e5e6e6;
	border-radius: 0.75rem;
`

export const headerStyle = css`
	border-bottom: 4px solid #0b75e1;
	padding-bottom: 0.875rem;
	text-align: center;
	margin-bottom: 1.25rem;
`

export const searchBarContainer = css`
	padding: 1.25rem 1.5rem;
	border-bottom: 1px solid #e5e6e6;
`

export const tableContainer = css`
	overflow: hidden;

	& .MuiTableRow-root td {
		padding: 0.75rem 1.5rem;
	}

	& .MuiTableRow-root td:last-child {
		text-align: right;
	}
`

export const pagination = css`
	padding: 1rem 1.25rem;
	border-radius: 0 0 0.75rem 0.75rem;
	border-top: 1px solid #e5e6e6;
`

export const noDocuments = css`
	text-align: center;
	margin: 6rem 0;

	h4 {
		text-transform: none;
		font-size: 16px;
		font-weight: 700;
		color: #6b7280;
	}

	p {
		font-size: 14px;
		color: #6b7280;
	}
`
